export function isNode(e: any): e is Node {
  return !!(e && 'nodeType' in e)
}
